import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client - exported so it can be cleared on logout
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Global defaults for all queries
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes — keep unused cache longer to reduce refetches on back-navigation
      retry: (failureCount, error) => {
        // Don't retry on 401/403 errors
        if (
          error instanceof Error &&
          (error.message.includes("401") || error.message.includes("403"))
        ) {
          return false;
        }
        // Retry up to 2 times for other errors (single retry owner — ApiClient retries disabled)
        return failureCount < 2;
      },
      refetchOnWindowFocus: false, // Disable refetch on window focus by default
      refetchOnMount: true, // Always refetch when component mounts
      refetchOnReconnect: true, // Refetch when reconnecting
    },
    mutations: {
      // Global defaults for all mutations
      retry: false, // Don't retry mutations by default
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default QueryProvider;
